import React, { useState, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import { Col, Placeholder } from "rsuite";
import "bootstrap/dist/css/bootstrap.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faPlus,
  faPen,
  faTimes,
  faUndo, faFileExcel
} from "@fortawesome/free-solid-svg-icons";
import apiUrl from "../../apiUrlConstant";
import { Formik, Form, Field, ErrorMessage } from "formik";
import DataTable, {
  createTheme,
  defaultThemes,
} from "react-data-table-component";
import datatableOptions from "../../layout/datatableConstants";
import { Link } from "react-router-dom";
import styled1 from "styled-components";
import { Modal, Button } from "react-bootstrap";
import { numberFormat } from "../../utils/index";

const TextField = styled.input`
  height: 32px;
  width: 200px;
  border-radius: 3px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border: 1px solid #e5e5e5;
  padding: 0 32px 0 16px;

  &:hover {
    cursor: pointer;
  }
`;

const ClearButton = styled.button`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  columns={columns}
  height: 34px;
  width: 32px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color:#003970;
`;

const StyledCell1 = styled1.div`
  &.low {
    background: green !important;
  }
  &.medium {
    background: orange;
  }
  &.high {
    background: red !important;
  }
`;

const StyledCell = ({ }) => (
  <b></b>
)

const FilterComponent = ({ filterText, onFilter, onClear, prm, fetchUrl, showExport }) => (
  (typeof showExport == "undefined" || showExport) &&
  <>
    <a href={fetchUrl + prm + '&export=true'}>
      <ClearButton type="button" onClick={fetchUrl + prm + '&export=true'} className="download_button">
        Download
      </ClearButton>
    </a>
  </>
);

//const RevenueTable = ({asset, brand, formConfig, expiry_report , expiry_lockin_report, fetchUrl, }) => {
const RevenueTable = ({ asset, brand, formConfig, expiry_report, expiry_lockin_report, fetchUrl, showExport }) => {

  if (typeof formConfig == "undefined") {
    formConfig = {
      'page': 0, 'per_page': 10
    };
  }

  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [columns, setColumns] = useState([]);
  const [keyCounter, setkeyCounter] = useState(0);
  const [showReceipt, setShowReceipt] = useState(false);
  const [paymentData, setPaymentData] = useState([]); 

  React.useEffect(() => {
    fetchLeaseData(1);
  }, [filterText]);

  const conditionalRowStyles = [
    {
      when: row => row.toggleSelected,
      style: {
        backgroundColor: "green",
        userSelect: "none"
      }
    }
  ];
  const subHeaderComponentMemo = React.useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };


    var prm = Object.entries(formConfig).map(([key, val]) => `${key}=${val}`).join('&');
    return (
      <FilterComponent
        onFilter={(e) => {
          setFilterText(e.target.value);
        }}
        onClear={handleClear}
        filterText={filterText}
        prm={prm}
        fetchUrl={fetchUrl}
        showExport={showExport}
      />
    );
  }, [filterText, resetPaginationToggle]);

  const fetchLeaseData = async (page) => {


    let pageCnt = page ? page : 0;
    formConfig["page"] = pageCnt;
    formConfig["per_page"] = perPage;

    if (typeof expiry_report != "undefined" && expiry_report == "true") {
      formConfig['expiry_report'] = 'true';
    }

    if (typeof expiry_lockin_report != "undefined" && expiry_lockin_report == "true") {
      formConfig['expiry_lockin_report'] = 'true';
    }

    var prm = Object.entries(formConfig).map(([key, val]) => `${key}=${val}`).join('&');
    console.log(prm, "prm");


    setLoading(true);
    //asset=${asset}&brand=${brand}&page=${page}&per_page=${perPage}&delay=1&term=${filterText}`
    const response = await axios.get(
      `${fetchUrl}` + prm
    );

    if (typeof response.data.data != "undefined" && response.data.data.length > 0) {

      const updatedData = response.data.data.map(item => {
        if (item.srNo !== item.srNo) {
          return item;
        }

        //item.assetName = eval("<b>"+item.assetName+"</b>")

        return {
          ...item,
          toggleSelected: !item.toggleSelected
        };
      });

      setData(updatedData);
    } else {
      setData(response.data.data);
    }


    setTotalRows(response.data.total);
    if(eval(response.data.gridColumns)!==undefined) {
      //setColumns(eval(response.data.gridColumns));

      const gridColumns = response.data.gridColumns ? eval(response.data.gridColumns) : [];
      const updatedColumns = gridColumns.map((column) => {
        if (column.name.toLowerCase().includes("receipt") ) {
          return {
            ...column,
            cell: (row) => (
              row[column.selector] > 0 ? (
                <a href="#" onClick={() => handleRentClick(row,column.name)}>
                  {row[column.selector]}
                </a>
              ) : row[column.selector]
            ),
          };
        }
        return column;
      });

      const visibleColumns = updatedColumns.filter(column => column.visible !== false);

      setColumns(visibleColumns);
    }
    

    setkeyCounter(Math.round());
    setLoading(false);
  };

  const handleRentClick = (row, column) => {
    try {
      axios({
        method: "get",
        url: `${apiUrl.apiUrl.url + '/charge-receipt/payment-list?lease_id=' + row.leaseId + '&month=' + column + '&type='+row.type}`,
        data: {}
      }).then(function (response) {
        setPaymentData(response.data.data); 
        if(response.data.data.length > 0) {
          setShowReceipt(true);
        }
      });
    } catch (error) {
      console.error("Error downloading file: ", error);
    }
    
  };

  const closeReceiptModal = () => {
    setShowReceipt(false);
  }

  const handlePageChange = (page) => {
    fetchLeaseData(page);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setLoading(true);
    let pageCnt = page ? page : 0;
    formConfig["page"] = pageCnt;
    formConfig["per_page"] = perPage;
    if (typeof expiry_report != "undefined") {
      formConfig['expiry_report'] = 'true';
    }
    var prm = Object.entries(formConfig).map(([key, val]) => `${key}=${val}`).join('&');
    console.log(prm, "prm");

    const response = await axios.get(
      `${fetchUrl}` + prm
    );


    // const response = response.data.data.map(item => {
    //   if (row.id !== item.id) {
    //     return item;
    //   }

    //   return {
    //     ...item,
    //     toggleSelected: !item.toggleSelected
    //   };
    // });

    //setData(updatedData);

    //`${apiUrl.apiUrl.url}/lease-report/get-all-leases?asset=${asset}&brand=${brand}&page=${page}&per_page=${newPerPage}&delay=1`
    setData(response.data.data);
    setPerPage(newPerPage);
    setLoading(false);
  };

  useEffect(() => {
    fetchLeaseData(1);
  }, []);

  const handleRowClicked = row => {
    const updatedData = data.map(item => {
      if (row.id !== item.id) {
        return item;
      }

      return {
        ...item,
        toggleSelected: !item.toggleSelected
      };
    });

    setData(updatedData);
  };

  function getCssClass(value) {
    if (value > 5000) return "high";
    else if (value > 500) return "medium";
    return "low";
  }

  // subHeaderComponent={subHeaderComponentMemo}
  return (
    <>
      <div className="tableContainer revenueTable">
        <DataTable
          //key={keyCounter}
          
          columns={columns}
          //direction={auto}
          data={data}
          customStyles={datatableOptions.datatableOptions.customStyle}
          progressPending={loading}
          pagination
          paginationServer
          paginationTotalRows={totalRows}
          onChangeRowsPerPage={handlePerRowsChange}
          subHeader
          subHeaderComponent={subHeaderComponentMemo}
          onChangePage={handlePageChange}
          //onRowClicked={handleRowClicked}

          //conditionalRowStyles={conditionalRowStyles}
          paginationComponentOptions={
            datatableOptions.datatableOptions.paginationOptions
          }
        />
      </div>

      <Modal show={showReceipt} onHide={closeReceiptModal} >
        <Modal.Header closeButton>
          <Modal.Title>Receipt Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        {paymentData && paymentData.length > 0 ? (
          <table className="table table-striped">
            <thead>
              <tr>
                <th>Sr</th>
                <th>Amount</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
            {paymentData.map((payment, index) => {
              const date = new Date(payment.receipt_date);
              const formattedDate = `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;

              return (
                <tr key={index}>
                  <td>{index+1  }</td>
                  <td>{numberFormat(payment.amount)}</td>
                  <td>{payment.receipt_date}</td>
                </tr>
              );
            })}
            </tbody>
          </table>
        ) : (
          <p>No payment data available.</p>
        )}
        </Modal.Body>
      </Modal>
    </>
  );
};
export default RevenueTable;
